import { createSlice, } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  isAuthenticated: false,
  user:{},
  timestamp: null,
 
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.timestamp= dayjs()
    },
    setLogout: (state) => {
      state.isAuthenticated = false;
      state.user = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuth, setLogout } = authSlice.actions;

export default authSlice.reducer;
